<template>
  <div class="card"  v-if="hasAccess">
    <div class="card-header">
      <div class="row mb-2">
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام کالا</span>
            </div>
          </div>
          <input
            v-model="product.name"
            type="text"
            v-bind:class="{ 'hover-pointer': mode!=='view' }"
            class="form-control"
            @click="openProductModal"
            placeholder="کلیک کنید"
            readonly
          >
        </div>
        <div class="col-9 text-left">
          <button class="btn btn-info" @click="onPrintClicked"><i class="fa fa-print"></i></button>
        </div>
      </div>
    </div>
    <div class="card-body"  id="printMe">
      <div class="row">
        <!--<div class="col-sm-12 text-center">-->
          <!--<span class="">گزارش کاردکس کالای :-->
          <!--{{product.name}}</span>-->
          <!--</div>-->
        <div class="col-sm-12">
          <!--          <vs-table ref="table" v-if="show" :params="params" :options="options"></vs-table>-->
          <table class="table table-striped my-3">
            <thead>
            <tr>
              <th scope="col" class="text-center">#</th>
              <th scope="col" class="text-center">شناسه سند</th>
              <th scope="col" class="text-center">تاریخ سند</th>
              <th scope="col" class="text-center">نوع سند</th>
              <th scope="col" class="text-center">عنوان سند</th>
              <th scope="col" class="text-center">تحویل دهنده</th>
              <th scope="col" class="text-center">تحویل گیرنده</th>
              <th scope="col" class="text-center">ورودی</th>
              <th scope="col" class="text-center">خروجی</th>
              <th scope="col" class="text-center">موجودی</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) of kardexResultPagination">
              <td class="text-center">{{((pageIndex - 1) * pageSize) + (index + 1)}}</td>
              <td class="text-center">{{item.voucherId}}</td>
              <th scope="row" class="text-center">{{changeDateFormat(item.voucherDate)}}</th>
              <th scope="row" class="text-center">{{item.voucherType}}</th>
              <th scope="row" class="text-center">{{item.documentType}}</th>
              <th scope="row" class="text-center">{{item.voucherServeName}}</th>
              <th scope="row" class="text-center">{{item.voucherReciveName}}</th>
              <td class="text-center">{{checkNullable(item.entrance)}}</td>
              <td class="text-center">{{checkNullable(item.output) + "-"}}</td>
              <td class="text-center">{{item.stock}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" style="display:flex;color:yellow;">
        <div style="flex-grow:4.4"></div>
        <div style="flex-grow:0.5" class="d-flex justify-content-center sum">{{entrancesSum}}</div>
        <div style="flex-grow:0.5" class="d-flex justify-content-center sum">{{outputsSum}}</div>
        <div style="flex-grow:0.5" class="d-flex justify-content-center sum">{{stock}}</div>
      </div>
      <div class="col-12" v-if="showPagination">
        <b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"
                      @input="nextPage(pageIndex)"/>
      </div>
    </div>
    <b-modal
      ref="modal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onSelectProductOk"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowSelect="selectProduct"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import Products from "./Products.vue";
  import Moment from "moment-jalali";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import BdSelectCompanyModal from "../components/BDSelectCompanyModal.vue";
  // import BdProductOrderModal from "../components/BDProductOrderModal.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Utils from "../_framework/utils/Utils.js";
  import VueHtmlToPaper from 'vue-html-to-paper';

  export default {
    name: "kardex",
    components: {
      VsTable,
      Moment,
      datePicker: DatePicker,
      VsSelect,
      BdSelectCompanyModal,
      // BdProductOrderModal,
      Products
    },
    data() {
      return {
        mode: "edit",
        hasAccess: true,
        access: {},
        show: true,
        product: {},
        kardexResult: [],
        currentDate: Moment().format("jYYYY/jMM/jDD"),
        entrancesSum: null,
        outputsSum: null,
        stock: null,
        rows: 0,
        pageSize: 10,
        pageIndex: 1,
        kardexResultPagination: [],
        showPagination: true,
        company: "",
        // currentEntrance : 0,
        // currentOutput : 0,
      };
    },
    methods: {
      onPrintClicked() {
        const title = document.title;
        document.title = "پرینت کاردکس کالا : " + this.product.name;
        this.$htmlToPaper('printMe');
        document.title = title;
      },
      getKardex(id, togglePagination = false) {
        if (togglePagination) {
          this.showPagination = false;
        }
        new BaseService('Voucher', `/GetKardex/${id}`).getList().then((response) => {
          console.log(response.data)
          this.kardexResult = response.data;
          this.rows = this.kardexResult.length;
          this.calcStock();
          this.nextPage(this.pageIndex);
        }).catch((error) => {
          console.log(error)
        }).then(() => {
          if (togglePagination) {
            this.showPagination = true;
          }
        })
      },
      nextPage(index) {
        const nextIndex = (index - 1) * this.pageSize;
        this.kardexResultPagination = this.kardexResult.slice(nextIndex, nextIndex + this.pageSize);

      },
      onSelectProductOk() {
        this.hideModal();
        this.show = false;
        let self = this;
        setTimeout(() => {
          this.show = true;
        }, 50);
        setTimeout(() => {
          let data = self.$refs.table.$data.list.data;
          let entrances = data.map(d => d.entrance);
          let outputs = data.map(d => d.output);
          this.entrancesSum = entrances.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.outputsSum = outputs.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.stock = data[data.length - 1].stock;
        }, 500);
      },
      selectProduct(prod) {
        this.product.id = prod.id;
        this.product.name = prod.productName;
      },
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();
        /* if (this.$refs.productsContainer.hasChildNodes) {
             this.$refs.productsContainer.removeChild(
                 this.$refs.productsContainer.childNodes[0]
             );
         }*/
        // this.$refs.productsContainer.appendChild(_products.$el);
        if (this.$refs && this.$refs.modal) {
          this.$refs.modal.show();
        }
        _products.$on("onRowSelect", row => {
          this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      hideModal() {
        this.$refs.modal.hide();
      },
      openVoucher(_mode, id) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
        this.$router.push({
          path: "/voucher",
          query: {id, _mode}
        });
      },
      openProductDetailModal(val) {
        // console.log(val)
        this.getKardex(val.id);
        this.$refs.modal.hide();
        // let ComponentClass = Vue.extend(BdProductOrderModal);
        // let pdModal = new ComponentClass({
        //     propsData: {
        //         model: this.productOrderModel
        //     }
        // });
        // pdModal.$mount();
        // // this.$refs.container.appendChild(pdModal.$el);
        // setTimeout(() => {
        //     pdModal.openModal();
        // }, 200);
        // pdModal.$on("onProductOrderModalOk", mode => {
        //     if (mode === "create") {
        //         this.addOrderRow();
        //     } else if (mode === "update") {
        //         this.updateOrderRow();
        //     }
        // });
      },
      checkNullable(val) {
        if (val) {
          return val;
        } else {
          return "-"
        }
      },
      calcStock() {
        for (let i = 0; i < this.kardexResult.length; i++) {
          let stock;
          let stockPrice;
          if (i !== 0) {
            stock = this.kardexResult[i - 1].stock;
            stockPrice = this.kardexResult[i - 1].stockPrice;
          } else {
            stock = i;
            stockPrice = i;
          }
          // voucherReciveName
          // voucherServeName
          if (this.company === this.kardexResult[i].voucherReciveName) {
            if (this.kardexResult[i].entrance !== 0) {
              // this.currentEntrance = this.kardexResult[i].entrance;
              this.kardexResult[i].stock = stock + this.kardexResult[i].entrance;
              this.kardexResult[i].stockPrice = this.kardexResult[i].voucherType === "ورود"
                ? ((this.kardexResult[i].price * this.kardexResult[i].unitVal) + (stock * stockPrice)) / this.kardexResult[i].stock
                : stockPrice;
            } else {
              this.kardexResult[i].stock = stock + this.kardexResult[i].output;
              this.kardexResult[i].stockPrice = this.kardexResult[i].voucherType === "ورود"
                ? ((this.kardexResult[i].price * this.kardexResult[i].unitVal) + (stock * stockPrice)) / this.kardexResult[i].stock
                : stockPrice;
              this.kardexResult[i].entrance = this.kardexResult[i].output;
              this.kardexResult[i].output = 0;
              this.kardexResult[i].voucherType = "ورود"
            }
          }
          if (this.company === this.kardexResult[i].voucherServeName) {
            // this.currentOutput = this.kardexResult[i].output;

            this.kardexResult[i].stock = stock - this.kardexResult[i].output;
            this.kardexResult[i].stockPrice = this.kardexResult[i].voucherType === "ورود"
              ? ((this.kardexResult[i].price * this.kardexResult[i].unitVal) + (stock * stockPrice)) / this.kardexResult[i].stock
              : stockPrice;

          }
          // this.kardexResult[i].stock = stock + this.kardexResult[i].entrance - this.kardexResult[i].output;
          // this.kardexResult[i].stockPrice = this.kardexResult[i].voucherType === "ورود"
          //   ? ((this.kardexResult[i].price * this.kardexResult[i].unitVal) + (stock * stockPrice)) / this.kardexResult[i].stock
          //   : stockPrice;
        }
      },
      changeDateFormat(val) {
        let resultDate = ""
        if (val) {
          let date = Moment(val, "YYYY/MM/DD");
          resultDate = date.format("jYYYY/jMM/jDD");
          return resultDate
        } else {
          return "-"
        }
      }
      /*  stockCalculator(index, entrance, output) {
            let stock;

            if(index !== 0) {
                stock = this.kardexResult[index - 1].stock;
            } else {
                stock = index;
            }
            this.kardexResult[index].stock = stock + (entrance + (output * -1));
            return this.kardexResult[index].stock;
        }*/
    }
    ,
    beforeMount() {
      /*this.options.access = checkAccess(this.$route.path);
      this.hasAccess = !!this.options.access;*/
    }
    ,
    mounted() {
      this.company = localStorage.getItem("company");
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
    }
    ,
    created() {
    }
    ,
    computed: {}
    ,
    watch: {}
  }
  ;
</script>

<style scoped>
  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

  .hover-pointer:hover {
    cursor: pointer;
  }

  .sum {
    color: white;
    font-weight: bold;
  }
</style>
